import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/Css/Login.css";
import logo from "../../assets/Img/logo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("https://network.rentel.in/admin/login", {
        email,
        password,
      });

      if (res.data.token) {
        // Save token for later API calls
        localStorage.setItem("adminToken", res.data.token);
        // console.log("✅ Login successful:", res.data);

        // Optional: save admin info
        localStorage.setItem("adminInfo", JSON.stringify(res.data.adminInfo));

        // Navigate to dashboard
        navigate("/dashboard");
      } else {
        setError("Invalid login response from server.");
      }
    } catch (err) {
      // console.error("❌ Login failed:", err);
      setError("Invalid email or password.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src={logo} alt="Rentel Logo" className="login-logo" />
        <h2 className="login-title">
          Sign In to <span className="highlight">Rentel</span>
        </h2>
        <p className="login-subtitle">
          Welcome back! Please enter your details.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <label>Email</label>
          <input
            type="email"
            placeholder="mail@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="login-btn">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
